<script lang="ts">
  import { strokeColor, strokeAbbrev, contrastTextOn } from "./designTokens";

  interface Props {
    stroke: string;
    /** "default" matches lap-row pills; "small" matches the worst-laps row. */
    size?: "default" | "small";
  }
  let { stroke, size = "default" }: Props = $props();
</script>

<!-- Text color picked per fill: the old fixed bg-canvas text was near-black on
     the midnight stroke blues (FREE on #1A2A44 unreadable). Only backstroke
     yellow earns dark text. -->
<span
  class="pill"
  class:small={size === "small"}
  style:background={strokeColor(stroke)}
  style:color={contrastTextOn(strokeColor(stroke))}
>
  {strokeAbbrev(stroke)}
</span>

<style>
  .pill {
    display: inline-block;
    padding: 0.1rem 0.4rem;
    border-radius: 3px;
    font-size: 0.65rem;
    font-weight: 700;
    /* color set inline per fill via contrastTextOn() */
    letter-spacing: 0.5px;
    text-align: center;
  }
  .pill.small {
    padding: 0.05rem 0.3rem;
    border-radius: 2px;
    font-size: 0.6rem;
  }
</style>
